import { TEXT_SEPARATOR } from "../utils/constants";
import { IGroupContract } from "../domain/group/group-contract";
import { formatDateShort } from "./date.util";

export const getFormattedContractTitle = (contract: IGroupContract): string => {
  const endDate = contract.endDate ? ` - ${formatDateShort(contract.endDate)}` : ``;
  return `${contract.contractNumber}${TEXT_SEPARATOR} ${formatDateShort(contract.startDate)}${endDate}`;
};

export const getFormattedContractSubtitle = (
  contract: IGroupContract,
): string => {
  return `${contract.takeBackSystemName ? `${contract.takeBackSystemName}` : "-"}`;
};
